import React, { useState, useEffect } from "react";
import Layout from "../../components/Layout/Layout";
import { FormGroup, CustomInput, Label } from "reactstrap";

import "./styles.scss";
import StoreItem from "../../components/StoreItem/StoreItem";
import { Link, useHistory } from "react-router-dom";

import ViewMore from "../../components/ViewMore/ViewMore";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import { fetchAllProducts, fetchSearch } from "../../redux/actions/products";
import { fetchCategory } from "../../redux/actions/category";

import storeId from "../../config/storeId";

import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

const MarketOne = (props) => {
  const store = storeId();
  const history = useHistory();
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState([]);
  const [pageCount, setPage] = useState(10);
  const [search, setSearch] = useState({ text: "" });
  const [check, setCheck] = useState(false);

  function viewMore() {
    props.fetchAllProducts(pageCount);
    setPage(pageCount + 10);
  }

  function changeOrder(e) {
    e.target.value === ("oldest" || "latest") &&
      setSearch({
        ...search,
        order: "createdAt",
        orderVal: e.target.value === "oldest" ? "ASC" : "DESC",
      });
    e.target.value === ("lowest_p" || "highest_p") &&
      setSearch({
        ...search,
        order: "net_price",
        orderVal: e.target.value === "lowest_p" ? "ASC" : "DESC",
      });
    e.target.value === ("lowest_r" || "highest_r") &&
      setSearch({
        ...search,
        order: "rating",
        orderVal: e.target.value === "lowest_r" ? "ASC" : "DESC",
      });
  }

  function handleChange(e) {
    e.preventDefault();
    setCheck(true);
    props.fetchSearch(search);
  }

  useEffect(() => {
    props.fetchCategory();
    props.fetchAllProducts();
  }, []);

  useEffect(() => {
    if (props.products.products.data) {
      setProducts(props.products.products.data.product);
    }
  }, [props.products.products]);

  useEffect(() => {
    if (props.search.search.data) {
      setProducts(props.search.search.data.product);
      setCheck(false);
    }
  }, [props.search.search.data]);

  useEffect(() => {
    if (props.category.category.data) {
      setCategory(props.category.category.data.store.categories);
    }
  }, [props.category.category]);

  return (
    <Layout>
      <NotificationContainer />
      <section className="market-container">
        <section className="row market-search">
          <div className="col-md-3 col-lg-3 col-xs-12">
            <p className="market-store-title">{store}</p>
          </div>
          <div className="col-md-9 col-lg-9 col-xs-12">
            <div className="market-search-form">
              <button
                className="btn"
                disabled={search.text === "" ? true : false}
                onClick={handleChange}
              >
                <i
                  class="fa fa-search market-search-icon"
                  aria-hidden="true"
                ></i>
              </button>

              <input
                type="text"
                placeholder="Enter Search"
                className="market-search-input"
                onChange={(e) => setSearch({ ...search, text: e.target.value })}
              />
            </div>
          </div>
        </section>

        <section className="market-product-container row">
          <div className="col-md-3 col-lg-3 col-xs-12 store-grid">
            <div className="market-filter-container">
              <p className="market-filter-text">FILTER BY</p>

              <div className="input-group mb-3 ">
                <select
                  className="custom-select market-filterby-option"
                  id="inputGroupSelect01"
                  value={search.catId}
                  onChange={(e) =>
                    setSearch({ ...search, catId: e.target.value })
                  }
                >
                  <option value="" selected>
                    Categories
                  </option>
                  {category.map((index, i) => {
                    return (
                      <option key={i} value={index.id}>
                        {index.name}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="form-group mb-3">
                <label htmlFor="">Minimum price</label>
                <input
                  type="number"
                  name="min"
                  className="form-control market-filterby-option"
                  placeholder="0"
                  value={search.min}
                  onChange={(e) =>
                    setSearch({ ...search, min: e.target.value })
                  }
                />
              </div>
              <div className="form-group mb-3">
                <label htmlFor="">Maximum price</label>
                <input
                  type="number"
                  name="max"
                  className="form-control market-filterby-option"
                  placeholder="1000000"
                  value={search.max}
                  onChange={(e) =>
                    setSearch({ ...search, max: e.target.value })
                  }
                />
              </div>

              <div className="input-group mb-3 ">
                <select
                  className="custom-select market-filterby-option"
                  id="inputGroupSelect01"
                  //value={e.target.value}
                  onChange={changeOrder}
                >
                  <option value="latest" selected>
                    Latest
                  </option>
                  <option value="oldest">Oldest </option>
                  <option value="lowest_p">Lowest price </option>
                  <option value="highest_p">Highest price </option>
                  <option value="lowest_r">Lowest rating </option>
                  <option value="highest_r">Highest rating </option>
                </select>
              </div>
              <button
                className="btn btn-outline-info btn-block"
                onClick={handleChange}
              >
                {!check ? (
                  "Filter"
                ) : (
                  <div>
                    <span
                      className="spinner-border spinner-border-sm mr-1"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Filtering...
                  </div>
                )}
              </button>
            </div>
          </div>
          {(products || []).map((item, i) => {
            return (
              <div className="col-md-3 col-lg-3 col-xs-12" key={i}>
                <StoreItem
                  price={item.net_price}
                  name={item.product_name}
                  desc={item.description}
                  photo={item.images[0]}
                  action={() => history.push(`/product/${item.product_slug}`)}
                  rating={item.rating}
                />
              </div>
            );
          })}
          {products.length < 1 && (
            <h3 className="text-center p-5">No product is available</h3>
          )}
        </section>
      </section>

      <ViewMore viewHandler={viewMore} />
    </Layout>
  );
};

MarketOne.propTypes = {
  products: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  products: state.products,
  category: state.category,
  search: state.search,
});

const pageActions = {
  fetchAllProducts,
  fetchCategory,
  fetchSearch,
};
export default connect(mapStateToProps, pageActions)(MarketOne);
